import styled from 'styled-components';
import ColorSF2 from './ColorSF2';

export const Main = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.5);
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

export const BaseDialog = styled.div`
  width: 529px;
  background-color: ${ColorSF2.white};
  @media (max-height: 530px) {
    height: 310px;
    overflow-y: auto;
  }
`;

export const Header = styled.div`
  height: 50px;
  background-color: ${ColorSF2.paleBlue};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  padding: 10px;
  margin-bottom: 10px;
  @media (max-height: 530px) {
    font-size: 14px;
    height: 40px;
  }
`;

export const Contents = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: ${props => (props.isCompanyAdminUser ? '0px' : '20px')};
`;

const buttonStyles = `
  width: 150px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  opacity: 1;
  font: normal normal normal 14px/21px Hiragino Kaku Gothic Pro;
  font-weight: bold;
  letter-spacing: 0.1px;
  &:hover {
    opacity: 0.5;
  }
`;

export const Button = styled.button`
  ${buttonStyles}
  cursor: pointer;
  border: none;
`;

export const CancelButton = styled(Button)`
  margin: 10px;
  background-color: ${ColorSF2.white};
  color: ${ColorSF2.black};
  border: 1px solid ${ColorSF2.mediumGray};
`;

export const DeleteButton = styled(Button)`
  margin: 10px;
  background-color: ${ColorSF2.red};
  color: ${ColorSF2.white};
`;

export const UpdateButton = styled(Button)`
  margin: 10px;
  background-color: ${ColorSF2.navyBlue};
  color: ${ColorSF2.white};
  &:disabled {
    cursor: not-allowed;
    background-color: ${ColorSF2.mediumGray};
  }
`;

export const LabelButton = styled.label`
  ${buttonStyles}
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 1px 10px 1px 10px;
  font-size: 14px;
  background-color: ${ColorSF2.white};
  min-height: 50px;
  @media (max-height: 530px) {
    margin: 1px 4px 1px 4px;
    font-size: 12px;
    min-height: 40px;
  }
`;

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
`;

export const CloseButtonImage = styled.img`
  width: 20px;
  height: 20px;
  @media (max-height: 530px) {
    width: 16px;
    height: 16px;
  }
`;

export const MessageItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ImportInput = styled.input`
  display: none;
`;
